import { atomWithStorage } from 'jotai/utils';

// Create the sidebar atom with localStorage persistence
export const sidebarCollapsedAtom = atomWithStorage<boolean>(
  '@actegon.gis.sidebar.collapsed',
  false, // Default value when nothing is stored in localStorage
);
